/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CompaniesByFirm = {
  company_id: number;
  status: number;
  al_id?: number;
  measurement_dates: Array<string>;
  firm_id: number;
  company_name: string;
  company_type?: CompaniesByFirm.company_type;
  fund_id: number;
  fund_name?: string | null;
  is_published: boolean;
  is_final: boolean;
  funds_fundownership: number;
  md_date?: string | null;
};
export namespace CompaniesByFirm {
  export enum company_type {
    HOLDING = 'holding',
    PORTFOLIO = 'portfolio',
    STANDALONE = 'standalone',
    INVESTMENT = 'investment',
  }
}
